import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
function Cart_6({ item }) {
  const customization = staticComponentValueConverter(item?.customization);

  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const products = useSelector(state => state.themeSlice.products);
  const firstProduct = products && Object.values(products)?.[0];

  return (
    <>
      <div className="w-full h-full relative flex flex-col">
        <div
          style={{
            margin: staticValues[10],
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            border: '1px solid #E5E5E5',
            color: 'var(--secondaryThemeColor)',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: staticValues[10],
            }}
          >
            <div style={{ display: 'flex', marginRight: staticValues[5] }}>
              <img
                style={{
                  width: 60,
                  borderRadius: 5,
                  height: '100%',
                  objectFit: customization?.backgroundSize,
                }}
                src={firstProduct?.image}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: staticValues[5] }}>
              <div
                style={{ textAlign: 'start', display: 'flex', flexDirection: 'column', gap: staticValues[5], flex: 1 }}
              >
                <div style={{ fontSize: staticValues[10], fontWeight: 'bold' }}>{firstProduct?.label}</div>
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: staticValues[5],
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: staticValues[10],
                  }}
                >
                  <div
                    style={{
                      padding: '0px 10px',
                      height: 30,
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'var(--thirdThemeColor)',
                      color: 'var(--fourthThemeColor)',
                      borderTopLeftRadius: 50,
                      borderBottomLeftRadius: 50,
                    }}
                  >
                    -
                  </div>
                  <div
                    style={{
                      padding: '0px 15px',
                      height: 30,
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'var(--firstThemeColor)',
                      color: 'var(--fourthThemeColor)',
                      borderTop: '1px solid var(--thirdThemeColor)',
                      borderBottom: '1px solid var(--thirdThemeColor)',
                    }}
                  >
                    1
                  </div>
                  <div
                    style={{
                      padding: '0px 10px',
                      height: 30,
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'var(--thirdThemeColor)',
                      color: 'var(--fourthThemeColor)',
                      borderTopRightRadius: 50,
                      borderBottomRightRadius: 50,
                    }}
                  >
                    +
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10, justifyContent: 'center' }}>
                  <svg fill="#000000" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6v12.5a2.5 2.5 0 0 1 -2.5 2.5h-9A2.5 2.5 0 0 1 5 18.5V6h-0.5a0.5 0.5 0 0 1 0 -1H9v-0.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V5h4.5a0.5 0.5 0 1 1 0 1zM6 6v12.5A1.5 1.5 0 0 0 7.5 20h9a1.5 1.5 0 0 0 1.5 -1.5V6zm8 -1v-0.5a0.5 0.5 0 0 0 -0.5 -0.5h-3a0.5 0.5 0 0 0 -0.5 0.5V5zm0 4.5a0.5 0.5 0 1 1 1 0v7a0.5 0.5 0 1 1 -1 0zm-5 0a0.5 0.5 0 0 1 1 0v7a0.5 0.5 0 1 1 -1 0z" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <div
                style={{
                  fontSize: staticValues[10],
                  textDecoration: 'line-through',
                  color: 'var(--secondaryThemeColor)',
                }}
              >
                ₺224.99
              </div>
              <div
                style={{
                  fontSize: staticValues[11],
                  color: '#E5280C',
                  fontWeight: 500,
                }}
              >
                ₺149.99
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cart_6;
